module.exports = __webpack_public_path__ + "img/car_list_icon.7653f47e.svg";